import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { phonePropType } from 'config/propTypes';

import { Container } from 'components/core/Page';
import { H1, Paragraph, Text } from 'components/core/Typography';
import { Image } from 'components/core/Image';
import { SearchBox } from 'components/search/SearchBox';
import { IconBanner } from 'components/core/IconBanner';
import { ClickToCall } from 'components/facility/ClickToCall';

import PlpHero from 'assets/images/landing/plp-hero.svg';
import PlpHeroGreen from 'assets/images/landing/plp-hero-green.svg';
import Swervy from 'assets/images/layout/wave-bg-light.svg';
import SpringFlower from 'components/svg/SpringFlower';
import MapPin from 'components/svg/MapPin';

import './MarketingHero.scss';

export function MarketingHero({
	onSearch,
	phone,
	getTollfreePhoneNumber,
	sf14850Variation,
}) {
	const showVariation1 = sf14850Variation === 'variation1';
	const showVariation2 = sf14850Variation === 'variation2';

	return (
		<section
			className={classnames('marketing-hero', {
				variation2: showVariation2,
			})}
		>
			<Container
				className={classnames('hero-container', {
					variation2: showVariation2,
				})}
			>
				{showVariation1 && (
					<Text
						size="smallMedium"
						color="promoGreen"
						weight="extraBold"
						className="savings-promo"
					>
						Spring Savings! Save up to 25% today
					</Text>
				)}
				{showVariation2 && (
					<IconBanner
						theme="savings-promo"
						bannerText={'Spring Savings!'}
						textColor="promoGreen"
						icon={<SpringFlower />}
					/>
				)}
				<div className="text-container">
					{showVariation2 ? (
						<H1
							color="white"
							size="xlarge"
							weight="extraBold"
							className="promo-heading"
						>
							Up to 25% off selected units!
						</H1>
					) : (
						<H1
							color="white"
							size="mediumLarge"
							weight="extraBold"
							className="main-heading"
						>
							Find the Cheapest <br /> Storage Units Near You
						</H1>
					)}
					{showVariation2 ? (
						<Paragraph
							size="small"
							color="white"
							weight="standard"
							className="info-text"
						>
							Compare prices across 10,000 + units
						</Paragraph>
					) : (
						<Paragraph
							size="small"
							color="white"
							weight="standard"
							className="info-text"
						>
							Compare and explore more self storage units than any
							other site.
						</Paragraph>
					)}

					<SearchBox
						onSearch={onSearch}
						icon={<MapPin fill="gray" />}
						useBrowserLocation
					/>
					<ClickToCall
						className={classnames('click-to-call', {
							variation2: showVariation2,
						})}
						phone={phone}
						onFetchNumber={getTollfreePhoneNumber}
					/>
				</div>
				<div className="images-container">
					{showVariation2 ? (
						<Image
							src={PlpHeroGreen}
							alt=""
							aria-hidden="true"
							className="moving-truck"
						/>
					) : (
						<Image
							src={PlpHero}
							alt=""
							aria-hidden="true"
							className="moving-truck"
						/>
					)}
					<Image
						src={Swervy}
						alt=""
						aria-hidden="true"
						className="swervy"
					/>
				</div>
			</Container>
		</section>
	);
}

MarketingHero.propTypes = {
	getTollfreePhoneNumber: PropTypes.func.isRequired,
	onSearch: PropTypes.func.isRequired,
	phone: phonePropType,
	sf14850Variation: PropTypes.string,
};

export default MarketingHero;
